import { IPV6_ADDRESS_MODE_LABELS, IPV6_PREFIX_MODE_LABELS } from '@simpleacs/shared';
import { IPV6_ADDRESS_MODES, IPV6_PREFIX_MODES, type Ipv6ChoiceMatrix } from '../../lib/wan-wizard';

/**
 * The gate's own sentences for the greyed IPv6 radios — the same words the
 * server would refuse with — behind a fold, because each names the probe
 * that would verify the cell and runs to three lines. Drawn by the WAN mode
 * wizard's IP protocol step and by the WAN card's IPv6 rows, which grey the
 * same radios off the same matrix. Nothing when every radio is live.
 */
export function Ipv6RefusalFold({ matrix }: { matrix: Ipv6ChoiceMatrix }) {
  const address = IPV6_ADDRESS_MODES.filter((m) => matrix.address[m].length > 0);
  const prefix = IPV6_PREFIX_MODES.filter((m) => matrix.prefix[m].length > 0);
  if (address.length + prefix.length === 0) return null;
  const named = [
    ...address.map((m) => `${IPV6_ADDRESS_MODE_LABELS[m]} (address)`),
    ...prefix.map((m) => `${IPV6_PREFIX_MODE_LABELS[m]} (prefix)`),
  ];
  return (
    <details className="text-xs text-muted">
      <summary className="cursor-pointer select-none">
        Why {named.join(', ')} {named.length === 1 ? 'is' : 'are'} greyed on this CPE
      </summary>
      <ul className="mt-2 space-y-1.5">
        {address.map((m) => (
          <li key={`a-${m}`}>
            <span className="font-medium text-ink">{IPV6_ADDRESS_MODE_LABELS[m]} address</span> — {matrix.address[m].join(' ')}
          </li>
        ))}
        {prefix.map((m) => (
          <li key={`p-${m}`}>
            <span className="font-medium text-ink">{IPV6_PREFIX_MODE_LABELS[m]} prefix</span> — {matrix.prefix[m].join(' ')}
          </li>
        ))}
      </ul>
    </details>
  );
}
